import { Resource } from 'i18next';

import { DittoSource } from '../types/DittoSource';
import { NestedTranslation } from '../types/NestedTranslation';
import { TranslationResources } from '../types/TranslationResources';

// Combine Ditto and local resources
export const combineResources = (source: DittoSource, oldResources: TranslationResources): Resource => {
  const combinedResources: Resource = {};

  for (const [locale, translations] of Object.entries(source.ditto_component_library)) {
    combinedResources[locale] = {
      translation: {
        ...((oldResources[locale] && oldResources[locale].translation) || {}),
        ...translations,
      },
    };
  }

  // Ensure old resources are included even if not overridden by Ditto
  for (const [locale, translations] of Object.entries(oldResources)) {
    if (!combinedResources[locale]) {
      combinedResources[locale] = translations;
    } else {
      combinedResources[locale].translation = {
        ...translations.translation,
        ...(combinedResources[locale].translation as NestedTranslation),
      };
    }
  }

  return combinedResources;
};
